export default __webpack_public_path__ + "static/media/A5_22.4a16604f.mp3";